exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".techcity-root,.techcity-root body{overscroll-behavior:none;overflow:hidden;height:100%;width:100%}.techcity-root #app[data-browser=ios]{position:fixed;top:0;left:0;bottom:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./components/tech-city/TechCityMap.vue
// module id = 2115
// module chunks = 80